(function () {
  'use strict';

  // The controller is loaded globally so it can bind controls injected into
  // the lazy mini-cart. Guard against any stale/duplicated theme reference.
  if (window._cartFrameUpsellLoaded) return;
  window._cartFrameUpsellLoaded = true;

  function formatMoney(pennies) {
    return '£' + (pennies / 100).toFixed(2);
  }

  function track(event, payload) {
    try {
      if (window.zaraz && typeof window.zaraz.track === 'function') {
        window.zaraz.track(event, payload || {});
      }
    } catch (e) { /* analytics never blocks UX */ }
  }

  function getSectionsToRender() {
    var sections = [];
    var mainItems = document.getElementById('main-cart-items');
    if (mainItems) sections.push({ id: 'main-cart-items', section: mainItems.dataset.id, selector: '.js-contents' });
    var mainFooter = document.getElementById('main-cart-footer');
    if (mainFooter) sections.push({ id: 'main-cart-footer', section: mainFooter.dataset.id, selector: '.js-contents' });
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({ id: 'main-cart-footer', section: mainFooter.dataset.id, selector: '.free-shipping' });
    }
    var miniCart = document.getElementById('mini-cart');
    if (miniCart) sections.push({ id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' });
    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    sections.push({ id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' });
    sections.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    return sections;
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : html;
  }

  function swapSections(responseSections) {
    getSectionsToRender().forEach(function (s) {
      var target = document.getElementById(s.id);
      if (!target || !responseSections[s.section]) return;
      var toReplace = target.querySelector(s.selector) || target;
      toReplace.innerHTML = getSectionInnerHTML(responseSections[s.section], s.selector);
    });
    // Thumbnail re-init after this innerHTML swap is handled centrally by the
    // MutationObserver in main-cart-items.liquid (covers every cart re-render
    // path), so no per-caller call is needed here.
  }

  function flashSuccess(lineKey) {
    if (!lineKey) return;
    var row = document.querySelector('[data-cart-item-key="' + lineKey + '"], tr[id$="' + lineKey + '"]');
    if (!row) return;
    row.classList.add('cart-frame-upsell-added');
    setTimeout(function () { row.classList.remove('cart-frame-upsell-added'); }, 1600);
  }

  function onSwatchClick(e) {
    var swatch = e.currentTarget;
    if (swatch.classList.contains('is-oos')) return;
    var root = swatch.closest('[data-frame-upsell]');
    if (!root) return;

    // Once a frame is in the cart the swatches stop being a chooser and start
    // describing what the customer owns, so clicking a different one has to
    // change the frame rather than silently re-arm a button that is no longer
    // there. Shopify cannot move a line to another variant, so swap = remove
    // then add; swapFrame reuses the existing remove and add paths.
    if (root.classList.contains('is-paired')) {
      if (swatch.classList.contains('is-selected')) return;
      swapFrame(root, swatch);
      return;
    }

    root.querySelectorAll('.cart-frame-upsell__swatch').forEach(function (s) {
      s.classList.remove('is-selected');
      s.setAttribute('aria-checked', 'false');
    });
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-checked', 'true');

    var cta = root.querySelector('[data-frame-upsell-add]');
    var priceEl = root.querySelector('[data-frame-upsell-price]');
    if (cta) cta.setAttribute('data-variant-id', swatch.getAttribute('data-variant-id'));
    if (priceEl) priceEl.textContent = formatMoney(parseInt(swatch.getAttribute('data-variant-price'), 10));

    track('frame_upsell_swatch', {
      variant_id: swatch.getAttribute('data-variant-id'),
      variant_label: swatch.getAttribute('data-variant-label') || '',
      print_size: root.getAttribute('data-print-size') || '',
      pair_code: root.getAttribute('data-pair-code') || ''
    });
  }

  function onAddClick(e) {
    var cta = e.currentTarget;
    if (cta.hasAttribute('disabled')) return;
    var root = cta.closest('[data-frame-upsell]');
    if (!root) return;

    // Source of truth = currently selected swatch, not the CTA's cached attribute.
    var selectedSwatch = root.querySelector('.cart-frame-upsell__swatch.is-selected:not(.is-oos)');
    var variantId = selectedSwatch
      ? selectedSwatch.getAttribute('data-variant-id')
      : cta.getAttribute('data-variant-id');
    if (!variantId) return;
    addFrameVariant(root, variantId, cta);
  }

  /**
   * Add `variantId` as a frame paired to this print.
   *
   * `cta` is optional: the add button exists only in the un-paired state, and a
   * colour swap calls this with no button to put into a loading state.
   */
  function addFrameVariant(root, variantId, cta) {
    cta = cta || null;
    var ctaText = cta && cta.querySelector('.cart-frame-upsell__cta-text');
    var ctaPrice = cta && cta.querySelector('.cart-frame-upsell__cta-price');
    var originalText = ctaText ? ctaText.textContent : '';
    if (cta) cta.setAttribute('disabled', 'true');
    if (ctaText) ctaText.textContent = 'Adding';
    if (ctaPrice) ctaPrice.style.display = 'none';
    root.classList.add('is-loading');

    var lineKey = root.getAttribute('data-print-line-key') || '';
    var lineRef = root.getAttribute('data-print-line-ref') || '';
    var printOrderId = root.getAttribute('data-print-order-id') || '';
    var pairLabel = root.getAttribute('data-pair-label') || 'print';
    var pairCode = root.getAttribute('data-pair-code') || '';
    var pairsWith = pairCode ? pairLabel + ' (#' + pairCode + ')' : pairLabel;
    var sectionIds = getSectionsToRender().map(function (s) { return s.section; }).filter(Boolean);

    // _paired_with_key is the display contract, but a cart line key dies
    // whenever the print is replaced (edit personalisations). The design's
    // _OrderID survives that, so it rides along as _frame_for_order_id and
    // lets reconcilePairAttributes re-link instead of reaping the frame.
    var frameProps = {
      'Pairs with': pairsWith,
      _paired_with_key: lineKey
    };
    // The copy this frame belongs to. Copies of one design share an _OrderID,
    // so without this a second copy of the same print claims the same frame.
    // Only set when the print actually is a copy: for a design's only line the
    // "ref" would just be the line key, which this store re-hashes on every
    // cart mutation, and a stale ref is worse than none.
    if (lineRef) frameProps._paired_with_line_ref = lineRef;
    if (printOrderId) frameProps._frame_for_order_id = printOrderId;

    var body = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: frameProps
      }],
      sections: sectionIds.join(','),
      sections_url: window.location.pathname
    };

    // Returned so a colour swap can await the add before it reports success.
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        // Stamp an order-level attribute so the pair code also persists on the print side
        // (admin-only — the leading underscore hides it from checkout and customer emails).
        if (!pairCode) return null;
        var attrKey = '_pair_' + pairCode;
        var attrBody = { attributes: {}, sections: sectionIds.join(','), sections_url: window.location.pathname };
        attrBody.attributes[attrKey] = pairLabel;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(attrBody)
        }).then(function (res) { return res.ok ? res.json() : null; });
      })
      .then(function (data) {
        if (data && data.sections) {
          swapSections(data.sections);
          init();
          flashSuccess(lineKey);
        } else {
          window.location.reload();
          return;
        }

        track('frame_upsell_add', {
          variant_id: variantId,
          print_size: root.getAttribute('data-print-size') || '',
          pair_code: pairCode,
          pair_label: pairLabel
        });

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'frame-upsell' } }));
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'frame-upsell' });
        }
      })
      .catch(function (err) {
        if (cta) cta.removeAttribute('disabled');
        if (ctaText) ctaText.textContent = originalText;
        if (ctaPrice) ctaPrice.style.display = '';
        root.classList.remove('is-loading');
        var msg = (err && err.description) || (err && err.message) || 'Sorry, we could not add that frame. Please try again.';
        alert(msg);
      });
  }

  function bind(root) {
    if (root.dataset.frameUpsellBound === '1') return;
    root.dataset.frameUpsellBound = '1';
    root.querySelectorAll('.cart-frame-upsell__swatch').forEach(function (s) {
      s.addEventListener('click', onSwatchClick);
    });
    var cta = root.querySelector('[data-frame-upsell-add]');
    if (cta) cta.addEventListener('click', onAddClick);
    observeImpression(root);
  }

  function bindPairedChips() {
    // The paired state now lives inside the upsell block itself (the swatch
    // with a tick + an "Added / Remove" row); .cart-frame-paired is the older
    // standalone chip, still bound so nothing breaks mid-deploy.
    document.querySelectorAll('.cart-frame-upsell__remove').forEach(function (btn) {
      if (btn.dataset.frameUndoBound === '1') return;
      btn.dataset.frameUndoBound = '1';
      btn.addEventListener('click', onUndoClick);
    });
    document.querySelectorAll('.cart-frame-paired').forEach(function (chip) {
      if (chip.dataset.frameUndoBound === '1') return;
      chip.dataset.frameUndoBound = '1';
      var btn = chip.querySelector('[data-frame-upsell-undo]');
      if (btn) btn.addEventListener('click', onUndoClick);
    });
  }

  var impressionObserver = null;
  function observeImpression(root) {
    if (root.dataset.frameImprSeen === '1') return;
    if (!('IntersectionObserver' in window)) {
      fireImpression(root);
      return;
    }
    if (!impressionObserver) {
      impressionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            fireImpression(en.target);
            impressionObserver.unobserve(en.target);
          }
        });
      }, { threshold: 0.5 });
    }
    impressionObserver.observe(root);
  }

  function fireImpression(root) {
    if (root.dataset.frameImprSeen === '1') return;
    root.dataset.frameImprSeen = '1';
    track('frame_upsell_impression', {
      print_size: root.getAttribute('data-print-size') || '',
      pair_code: root.getAttribute('data-pair-code') || ''
    });
  }

  /** Line key of the frame paired to this print, wherever the control sits. */
  function pairedFrameKey(el) {
    var host = el.closest('[data-paired-frame-key]');
    return host ? host.getAttribute('data-paired-frame-key') : null;
  }

  /** Remove the paired frame, then add the newly-picked colour in its place. */
  function swapFrame(root, swatch) {
    var frameKey = root.getAttribute('data-paired-frame-key');
    var variantId = swatch.getAttribute('data-variant-id');
    if (!frameKey || !variantId) return;
    root.classList.add('is-loading');

    removeFrameLine(frameKey)
      .then(function (ok) {
        if (!ok) throw new Error('remove failed');
        // addFrame reads the CTA for its variant, and in the paired state there
        // is no CTA — pass the variant explicitly instead.
        return addFrameVariant(root, variantId);
      })
      .then(function () {
        track('frame_upsell_swap', {
          variant_id: variantId,
          variant_label: swatch.getAttribute('data-variant-label') || '',
          pair_code: root.getAttribute('data-pair-code') || ''
        });
      })
      .catch(function () {
        root.classList.remove('is-loading');
        window.location.reload();
      });
  }

  function removeFrameLine(frameKey) {
    var sectionIds = getSectionsToRender().map(function (s) { return s.section; }).filter(Boolean);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: frameKey, quantity: 0, sections: sectionIds.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        // Deliberately NOT swapping sections here when a swap is mid-flight —
        // the add that follows re-renders anyway, and painting the unframed
        // state in between makes the frame visibly flicker off and on.
        return data || null;
      });
  }

  function onUndoClick(e) {
    var btn = e.currentTarget;
    if (btn.hasAttribute('disabled')) return;
    var frameKey = btn.getAttribute('data-paired-frame-key') || pairedFrameKey(btn);
    var chip = btn.closest('.cart-frame-paired, [data-frame-upsell]');
    if (!frameKey) return;
    btn.setAttribute('disabled', 'true');

    var sectionIds = getSectionsToRender().map(function (s) { return s.section; }).filter(Boolean);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: frameKey, quantity: 0, sections: sectionIds.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.sections) {
          swapSections(data.sections);
          init();
        } else {
          window.location.reload();
          return;
        }
        track('frame_upsell_undo', { pair_code: (chip && chip.getAttribute('data-pair-code')) || '' });
        reconcilePairAttributes();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'frame-upsell' } }));
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'frame-upsell' });
        }
      })
      .catch(function () {
        btn.removeAttribute('disabled');
      });
  }

  function init() {
    document.querySelectorAll('[data-frame-upsell]').forEach(bind);
    bindPairedChips();
  }

  // Print variant option2 → the frame product's size option. Mirrors the map
  // in snippets/cart-frame-upsell.liquid.
  var FRAME_SIZE_BY_PRINT_SIZE = {
    'A4': 'A4',
    '30 x 40 cm': '30cm x 40cm',
    '40 x 50 cm': '40cm x 50cm',
    '50 x 70 cm': '50cm x 70cm',
    '60 x 80 cm': '60cm x 80cm'
  };

  var frameVariantsPromise = null;
  function getFrameVariants() {
    if (!frameVariantsPromise) {
      frameVariantsPromise = fetch('/products/skylit-studio-frame.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return (p && p.variants) || []; })
        .catch(function () { frameVariantsPromise = null; return []; });
    }
    return frameVariantsPromise;
  }

  /** [option1, option2, …] of a cart.js line, whichever field the API filled. */
  function lineOptions(item) {
    if (item.variant_options && item.variant_options.length) return item.variant_options;
    return (item.options_with_values || []).map(function (ov) { return ov.value; });
  }

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  /**
   * A frame whose _paired_with_key no longer exists is not necessarily an
   * abandoned add-on: "Edit personalisations" replaces the print line, which
   * re-keys it and used to get the frame silently reaped here — the customer
   * paid for a frame, edited a date, and lost the frame.
   *
   * So: if the frame's design (_frame_for_order_id) still has an UNFRAMED
   * print in the cart with no frame of its own, re-add the frame against the
   * print's new key — same colour, sized to the print's current size, so a
   * size change during the edit heals too. Remove a stale frame only when its
   * design is gone, its print already has a (healthier) frame, or the
   * customer picked a Framed/Canvas variant in the editor (the frame is baked
   * into the print now; keeping the upsell line would double-charge them).
   *
   * ONE mutation per pass, re-reading the cart between passes: this store
   * re-hashes line keys after a mutation, so anything chained off a stale
   * snapshot can silently no-op (see purgeDesign / cart-attrs-sync). The
   * re-link is therefore split across passes — the add happens in one pass,
   * and the stale line is removed in the NEXT pass (by its fresh key) once
   * its print reads as claimed. An interruption at any point leaves a state a
   * later run converges from, and because a claimed print never accepts a
   * second frame, no state can ratchet duplicate frames into the cart.
   */
  var MAX_FRAME_PASSES = 8;
  function reconcileFrames() {
    var mutated = false;
    function pass(n) {
      if (n >= MAX_FRAME_PASSES) {
        console.warn('[cart-frame-upsell] frame reconcile hit the pass ceiling');
        return Promise.resolve(mutated);
      }
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || window.__skylitCartEditInFlight) return mutated;
          return nextFrameMutation(cart.items || []).then(function (did) {
            if (!did) return mutated;
            mutated = true;
            return pass(n + 1);
          });
        });
    }
    return pass(0);
  }

  /** The stable identifier for one physical copy of a print, or null. */
  function copyRef(item) {
    var p = (item && item.properties) || {};
    return p._cart_line_ref || null;
  }

  /**
   * Which print copy a frame belongs to, expressed as a key into `printsByRef`.
   *
   * _paired_with_line_ref is authoritative and survives the line-key re-hash
   * this store performs on every cart mutation. _paired_with_key is the older
   * contract: still honoured, but only while the key happens to be live.
   * Returns null when the owner cannot be resolved — see nextFrameMutation.
   */
  function frameOwner(frame, printsByRef, printByKey) {
    var p = (frame && frame.properties) || {};
    if (p._paired_with_line_ref) {
      return printsByRef[p._paired_with_line_ref] ? p._paired_with_line_ref : null;
    }
    if (p._paired_with_key && printByKey[p._paired_with_key]) {
      return refOf(printByKey[p._paired_with_key]);
    }
    return null;
  }

  /** The printsByRef key for a print line: its copy ref, else its line key. */
  function refOf(print) {
    return copyRef(print) || print.key;
  }

  /** Apply the single most urgent frame fix; resolves false when consistent. */
  function nextFrameMutation(items) {
    var prints = items.filter(function (it) {
      if (it.handle === 'skylit-studio-frame') return false;
      var p = it.properties || {};
      return !!(p._OrderID || p.OrderID);
    });

    var printsByRef = {};
    var printByKey = {};
    prints.forEach(function (p) {
      printsByRef[refOf(p)] = p;
      printByKey[p.key] = p;
    });

    var frames = items.filter(function (it) { return it.handle === 'skylit-studio-frame'; });

    var byRef = {};
    var orphan = null;
    var needsRefStamp = null;
    frames.forEach(function (f) {
      var owner = frameOwner(f, printsByRef, printByKey);
      if (!owner) {
        if (!orphan) orphan = f;
        return;
      }
      (byRef[owner] = byRef[owner] || []).push(f);
      // Resolved only by line key, but its print IS a copy: migrate it onto the
      // copy-scoped contract so the next re-hash does not orphan it.
      if (!f.properties._paired_with_line_ref && copyRef(printsByRef[owner]) && !needsRefStamp) {
        needsRefStamp = { frame: f, print: printsByRef[owner] };
      }
    });

    // 1. Two frame lines claiming one copy (an interrupted earlier fix):
    //    the customer chose one frame — drop the extra line.
    var refs = Object.keys(byRef);
    for (var i = 0; i < refs.length; i++) {
      if (byRef[refs[i]].length > 1) {
        return removeLine(byRef[refs[i]][1].key).then(function () { return true; });
      }
    }

    // 2. A merge-inflated frame line: never more units than its print has.
    for (var j = 0; j < refs.length; j++) {
      var f2 = byRef[refs[j]][0];
      var print2 = printsByRef[refs[j]];
      var allowed = print2 ? (Number(print2.quantity) || 1) : 1;
      if ((Number(f2.quantity) || 1) > allowed) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: f2.key, quantity: allowed })
        }).then(function () { return true; });
      }
    }

    // 3. An orphan frame: adopt it onto a print copy, or remove it.
    if (orphan) return adoptOrRemove(orphan, items, printsByRef, byRef);

    // 4. Migrate a legacy key-paired frame onto its copy's line ref.
    if (needsRefStamp) {
      return repairFrameProps(needsRefStamp.frame, needsRefStamp.print).then(function () { return true; });
    }

    return Promise.resolve(false);
  }

  /**
   * Re-point an existing frame line at `print` by rewriting its properties.
   *
   * Deliberately a rewrite rather than add-then-remove: with two copies of one
   * design in the cart, "add the replacement now, remove the stale line on a
   * later pass" let the stale line be adopted by the OTHER copy in between, so
   * a single reload turned one paid £14.99 frame into two. Rewriting mutates
   * one line and leaves no window in which two frames exist.
   *
   * /cart/change.js replaces the property dict wholesale, so send the full set.
   */
  function repairFrameProps(frame, print) {
    var label = (print.properties && print.properties.Title) || print.product_title || 'print';
    var code = String(print.key).split(':').pop().slice(0, 6).toUpperCase();
    var oid = (print.properties && (print.properties._OrderID || print.properties.OrderID)) ||
              (frame.properties && frame.properties._frame_for_order_id) || '';
    var props = {
      'Pairs with': code ? label + ' (#' + code + ')' : label,
      _paired_with_key: print.key
    };
    var ref = copyRef(print);
    if (ref) props._paired_with_line_ref = ref;
    if (oid) props._frame_for_order_id = oid;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: frame.key, quantity: frame.quantity || 1, properties: props })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  /**
   * A frame whose owner cannot be resolved is not necessarily abandoned:
   * "Edit personalisations" replaces the print line, and the key re-hash that
   * follows any cart mutation orphans frames on the old contract. Reaping those
   * would mean a customer pays for a frame, edits a date, and loses it.
   *
   * So: if the frame's design still has a print copy with no frame of its own,
   * adopt it there. Remove only when the design is gone, every copy already has
   * a frame, or the print is no longer an unframed Print variant (the customer
   * switched to Framed/Canvas in the editor — the frame is baked in now and
   * keeping the line would double-charge them).
   */
  function adoptOrRemove(frame, items, printsByRef, byRef) {
    var removeStale = function () { return removeLine(frame.key).then(function () { return true; }); };
    var oid = frame.properties && frame.properties._frame_for_order_id;
    if (!oid) return removeStale();

    var target = items.filter(function (it) {
      if (it.handle === 'skylit-studio-frame') return false;
      var p = it.properties || {};
      if ((p._OrderID || p.OrderID) !== oid) return false;
      return !byRef[refOf(it)];
    })[0];
    if (!target) return removeStale();
    if ((lineOptions(target)[0] || '') !== 'Print') return removeStale();

    // Size unchanged: keep the line the customer paid for and just re-point it.
    var frameSize = FRAME_SIZE_BY_PRINT_SIZE[lineOptions(target)[1] || ''];
    if (frameSize && (lineOptions(frame)[1] || '') === frameSize) {
      return repairFrameProps(frame, target).then(function () { return true; });
    }

    // Size changed during an edit, so the variant itself has to change and a
    // rewrite cannot do it. Fall back to add-then-remove, but only when the
    // design has a single print line — with copies present there is no way to
    // tell whose frame this was, and guessing is what duplicates it.
    var designPrints = items.filter(function (it) {
      if (it.handle === 'skylit-studio-frame') return false;
      var p = it.properties || {};
      return (p._OrderID || p.OrderID) === oid;
    });
    if (designPrints.length !== 1) return repairFrameProps(frame, target).then(function () { return true; });

    var colour = lineOptions(frame)[0] || '';
    if (!colour || !frameSize) return removeStale();

    return getFrameVariants().then(function (variants) {
      var variant = variants.filter(function (v) {
        return v.options && v.options[0] === colour && v.options[1] === frameSize && v.available !== false;
      })[0];
      if (!variant) return removeStale();

      var label = (target.properties && target.properties.Title) || target.product_title || 'print';
      var code = String(target.key).split(':').pop().slice(0, 6).toUpperCase();
      var props = {
        'Pairs with': code ? label + ' (#' + code + ')' : label,
        _paired_with_key: target.key,
        _frame_for_order_id: oid
      };
      var ref = copyRef(target);
      if (ref) props._paired_with_line_ref = ref;

      return removeLine(frame.key)
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: props }] })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('frame re-add failed');
          return r.json();
        })
        .then(function () {
          if (!code) return true;
          var attrBody = { attributes: {} };
          attrBody.attributes['_pair_' + code] = label;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(attrBody)
          }).then(function () { return true; }, function () { return true; });
        })
        .catch(function () { return true; });
    });
  }

  // Remove any `_pair_<code>` cart attribute whose matching frame line is no longer in the cart.
  // Runs on page load and after any cart update. Idempotent; safe to call often.
  var reconcileInFlight = false;
  function reconcilePairAttributes() {
    if (reconcileInFlight) return;
    // A customizer edit is mid remove-then-add: everything looks orphaned for
    // a moment. Same guard cart-attrs-sync uses.
    if (window.__skylitCartEditInFlight) return;
    reconcileInFlight = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return null;
        return reconcileFrames().then(function (mutated) {
          if (mutated) {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.ok ? r.json() : cart; })
              .then(function (fresh) { return { cart: fresh, removedOrphan: true }; });
          }
          return { cart: cart, removedOrphan: false };
        });
      })
      .then(function (result) {
        if (!result) return;
        var cart = result.cart;
        var removedOrphan = result.removedOrphan;
        var attrs = cart.attributes || {};
        var stalePairKeys = Object.keys(attrs).filter(function (k) { return k.indexOf('_pair_') === 0; });

        var activeCodes = {};
        (cart.items || []).forEach(function (item) {
          if (item.handle !== 'skylit-studio-frame') return;
          var pw = (item.properties && item.properties['Pairs with']) || '';
          var m = pw.match(/#([A-Z0-9]{4,12})/);
          if (m) activeCodes[m[1]] = true;
        });

        var sectionIds = getSectionsToRender().map(function (s) { return s.section; }).filter(Boolean);
        var toUnset = {};
        var hasStale = false;
        stalePairKeys.forEach(function (k) {
          var code = k.replace('_pair_', '');
          if (!activeCodes[code]) {
            toUnset[k] = '';
            hasStale = true;
          }
        });

        if (hasStale) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: toUnset, sections: sectionIds.join(','), sections_url: window.location.pathname })
          }).then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (data && data.sections) {
                swapSections(data.sections);
                init();
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'frame-upsell' } }));
              }
            });
        }

        if (removedOrphan) {
          // Orphan frame(s) were removed but no attrs changed — repaint sections so UI reflects it.
          return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionIds.join(',')), {
            headers: { 'Accept': 'application/json' }
          })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              if (!data) return;
              swapSections(data);
              init();
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'frame-upsell' } }));
            });
        }
      })
      .catch(function () { /* non-critical */ })
      .then(function () { reconcileInFlight = false; });
  }

  function boot() {
    init();
    // Avoid an extra /cart.js request on ordinary storefront page loads. The
    // lazy drawer has no frame markup until cartdrawer:opened fires below.
    // The cart page always reconciles: when an edit turned the print into a
    // Framed/Canvas variant the upsell block no longer renders at all, yet a
    // stale (row-hidden) frame line may still need removing.
    if (document.getElementById('main-cart-items') || document.querySelector('[data-frame-upsell], .cart-frame-paired')) {
      reconcilePairAttributes();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:updated', function (e) {
    init();
    // Skip reconcile when we triggered the update ourselves — the add path never leaves stale attrs.
    if (e && e.detail && e.detail.source === 'frame-upsell') return;
    reconcilePairAttributes();
  });
  document.addEventListener('gallery:frame-controls-ready', init);
  document.addEventListener('cart:refresh', boot);
  document.addEventListener('cartdrawer:opened', function () {
    init();
    reconcilePairAttributes();
  });
})();
